/* eslint-disable max-len */
//Wrapper control used to allow <ep-edit-status-inner> to be used without formGroupName divs and spans

// To use outside of ep-field or outside the context of a form, provide value and layout inputs as in the following example:
//   <ep-edit-status
//      class="pull-right"
//      [value]="location.Edit_Status"
//      [layout]="'row'"
//      >
//   </ep-edit-status>

import { Component, EventEmitter, Input, Optional, Output } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'ep-edit-status',
    template: `
    <ng-container *ngIf="_fieldFormGroup; else standalone">
      <span [formGroup]="_fieldFormGroup">
        <ep-edit-status-inner
          [formControlName]="_fieldName"
          [allowDelete]="allowDelete"
          [allowRestore]="allowRestore"
          [allowClone]="allowClone"
          [allowAddAvailable]="allowAddAvailable"
          [layout]="layout"
          (onDelete)="onDelete.emit()"
          (onClone)="onClone.emit()"
          (onRestore)="onRestore.emit()"
          (onAddAvailable)="onAddAvailable.emit()"
        ></ep-edit-status-inner>
      </span>
    </ng-container>
    <ng-template #standalone>
      <ep-edit-status-inner
        [allowDelete]="allowDelete"
        [allowRestore]="allowRestore"
        [allowClone]="allowClone"
        [allowAddAvailable]="allowAddAvailable"
        [layout]="layout"
        [ngModel]="value"
        [ngModelOptions]="{ standalone: true }"
        (onDelete)="onDelete.emit()"
        (onClone)="onClone.emit()"
        (onRestore)="onRestore.emit()"
        (onAddAvailable)="onAddAvailable.emit()"
      ></ep-edit-status-inner>
    </ng-template>
  `,
    standalone: false
})
export class EditStatusComponent {
    static key = 'EditStatusComponent'; // allows for dynamic component lookup in collection control

    _fieldName: string;
    _fieldFormGroup: UntypedFormGroup;
    protected _form: UntypedFormGroup;
    protected _formGroupPath: string;

    @Input()
    allowDelete: boolean = false;

    @Input()
    allowRestore: boolean = false;

    @Input()
    allowClone: boolean = false;

    @Input()
    allowAddAvailable: boolean = false;

    @Input()
    layout: string = 'form';

    @Output()
    onClone = new EventEmitter();

    @Output()
    onDelete = new EventEmitter();

    @Output()
    onRestore = new EventEmitter();

    @Output()
    onAddAvailable = new EventEmitter();

    @Input()
    formControlName: string = null; //obsolete parameter - for legacy error checking only

    @Input()
    controlPath: string = null;

    @Input()
    value: any; // for using ep-edit-status outside of a form

    constructor(@Optional() private rootFormGroup: FormGroupDirective) { }

    ngOnInit() {
        if (this.formControlName) {
            console.error(
                `Error: formControlName should not be used on <ep-edit-status> version 2.  Remove formControlName attribute from the <ep-edit-status> html element.  (formControlName=${this.formControlName})`
            );
        }

        // set the form by getting form property of the injected FormControlDirective
        if (this.rootFormGroup) {
            this._form = this.rootFormGroup.form;
        }

        let lastSegPos = null;

        if (this.controlPath) {
            lastSegPos = this.controlPath.lastIndexOf('.');
            this._formGroupPath = this.controlPath.slice(0, lastSegPos); //path to the formgroup
            this._fieldName = this.controlPath.slice(lastSegPos + 1);
        }

        //find direct parent form group of this field
        if (this._formGroupPath) {
            let fg: UntypedFormGroup = this._form;
            let paths: string[] = this._formGroupPath.split('.');
            paths.forEach((pathSeg) => {
                fg = <UntypedFormGroup>fg.controls[pathSeg];
            });
            this._fieldFormGroup = fg;
        }
    }
}
